module.exports = __webpack_public_path__ + "static/media/trofeus (4).b47fd730.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/fotos/Trofeus/trofeus (4).jpg
// module id = 368
// module chunks = 0